<template>
<div>
    <div class="page-mkt">
        <div class="title">
            {{title}}
        </div>
        <div class="content-mkt custom-scrollbar" v-html="consent"></div>
        <div class="divider"></div>
        <div class="text-center text-color">{{ lbl.privacySetting.marketing_consent.marketing_message }}</div>
        <b-row class="text-color">
            <b-col>
                <div class="d-flex justify-content-center">
                    <Checkbok class="check" :textLbl="lbl.privacySetting.marketing_consent.email" :setValue="checks.email" @input="onChangeCheckbox($event,'email')"></Checkbok>
                </div>
            </b-col>
            <b-col>
                <div class="d-flex justify-content-center">
                    <Checkbok class="check" :textLbl="lbl.privacySetting.marketing_consent.sms" :setValue="checks.sms" @input="onChangeCheckbox($event,'sms')"></Checkbok>
                </div>
            </b-col>
        </b-row>
        <div class="marketing-btn">
            <OrangeButton @onClick="onSubmit()">{{ lbl.privacySetting.marketing_consent.update }}</OrangeButton>
        </div>
    </div>
</div>
</template>

<script>
import Checkbok from '@/components/Input/CheckBox.vue';
import OrangeButton from '@/components/Button/OrangeButton.vue';
import LocaleMixin from '@/mixin/LocaleMixin';
export default {
    mixins: [LocaleMixin],
    props:{
        consent: String,
        checkChanel: Object,
        modalController: Object,
        title: String
    },
    components:{
        Checkbok,
        OrangeButton
    },
    data: function(){
        return {
            checks: this.checkChanel
        }
    },
    methods:{
        onChangeCheckbox: function(check,data){
            if(data == 'email'){
                this.checks.email = check;
            }
            if(data == 'sms'){
                this.checks.sms = check
            }
        },
        onSubmit: function(){
            if(!this.checks.sms && !this.checks.email){
                this.modalController.confirmModal
                    .setTitle(this.lbl.privacySetting.confirm_popup.title)
                    .setMsg(this.lbl.privacySetting.confirm_popup.msg)
                    .setBtnOk(this.lbl.privacySetting.confirm_popup.btnOk)
                    .setBtnCancel(this.lbl.privacySetting.confirm_popup.btnCancel)
                    .show()
                this.modalController.confirmModal.onClickOk(() => {
                    console.log('back to setting')
                })
                this.modalController.confirmModal.onClickCancel(() => {
                    this.$emit('onClick',this.checks);
                })
            }else{
                this.$emit('onClick',this.checks);
            }
        },
    }
}
</script>

<style lang="scss" scoped>
@import "@/style/base/base.scss";
@import "@/style/base/baseDisplay.scss";
@import "@/style/base/baseUtility.scss";
@import '../style/PrivacySetting.scss';
.marketing-btn {
    display: flex;
    justify-content: center;
    background: white;
    max-width: 1040px;
    margin: 0 auto;
    @include max-mobile{
        padding: 20px 16px;
        box-shadow: 0 -4px 10px 0 rgba(0, 0, 0, 0.15);
    }
    @include max-tablet{
        padding-top:28px ;
    }
}
.page-mkt{
    background-color: #fff;
    border-radius: 8px;
    padding: 30px 24px 20px 24px;
    // height: 746px;
    overflow: hidden;
    font-size: 16px;
    font-family: $ff-reg;
    color: $a-black-333333;
    @include max-mobile{
        height: 100%;
    }
    &.custom-scrollbar{
            @include scrollbar($a-gray-999999, $a-gray-cdcdcd)
        }
    .content-mkt{
        height: calc(100vh - 512px);
        overflow-x: hidden;
        font-size: 16px;
        font-family: "PRT-Regular";
        color: $a-black-333333;
        // background-color: $a-gray-f4f4f4;
        // padding: {
        //     top: 22px;
        //     bottom: 18px;
        //     left: 20px;
        //     right: 16px;
        // }
        &.custom-scrollbar{
            @include scrollbar($a-gray-999999, $a-gray-cdcdcd)
        }
        @include max-mobile{
            padding: 10px;
            height: calc(100vh - 285px);
        }
    }
    .divider {
        margin-top: 32px;
        margin-bottom: 20px;
        width: 100%;
        background:#cdcdcd;
        height: 1px;
        // @include max-mobile {
        //     display: none;
        // }
    }
}
</style>
